/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */

import React, { useEffect, useState } from 'react';
import { Text, View } from 'react-native';
import { styles } from './styles';
import { TwButton, TwPage, TwPageHeader, TwPinInput } from '@tw/tw-components-rn';
import { useStoreState } from '@tw/tw-runtime-react';
import { BfAppContext, BfLoginCodeSendStatus } from '@tw/tw-runtime';

export const AuthVerify = (props) => {
  const params = props.route.params;
  const phone = params?.phone;
  const [code, setCode] = useState<string>();
  const store = BfAppContext.getInstance().getLoginStore();
  //
  const codeSendTimeRemind = useStoreState(store, (state) => state.captchaStatus.countdown);
  const sendingStatus = useStoreState(store, (state) => state.captchaStatus.sendingStatus);
  //

  const onCodeFullFill = async (code: string) => {
    store.updateLoginForm({
      captcha: code
    });
    await store.login();
  };
  const onSendCode = () => {
    store.sendCaptcha();
  };
  useEffect(() => {
    store.sendCaptcha();
  }, [store]);

  return (
    <TwPage translucentStatusBar={true} style={styles.container}>
      <TwPageHeader showBack={true} />
      <View style={styles.content}>
        <Text style={styles.titleContainer}>输入手机号验证码</Text>
        <Text style={styles.tips}>请输入发送至{phone}的6位验证码，有效期10分钟</Text>
        <View style={styles.pinCode}>
          <TwPinInput
            value={code}
            onChangeText={setCode}
            cellSize={60}
            codeLength={4}
            autoFocus={true}
            autoCellSize={false}
            onFulfill={onCodeFullFill}
          />
        </View>

        {sendingStatus === BfLoginCodeSendStatus.afterSending ? (
          <Text style={styles.countDownText}>{`${codeSendTimeRemind / 1000}秒后可以重新获得验证码`}</Text>
        ) : (
          <TwButton isLoading={sendingStatus == BfLoginCodeSendStatus.sending} onPress={onSendCode}>
            获得验证码
          </TwButton>
        )}
      </View>
    </TwPage>
  );
};
